import type { WalterCommand, WalterSnapshot } from "./types.js";

const durableCommandTypes = new Set<WalterCommand["type"]>([
  "SET_PRIVACY", "MEMORY_SAVE", "MEMORY_FORGET", "TIMER_CREATE", "TIMER_CANCEL", "TIMER_COMPLETE",
  "NEWS_UPDATE", "SET_SETTING", "REQUEST_APPROVAL", "RESOLVE_APPROVAL", "COMPLETE_TURN", "WAKE", "SLEEP",
]);

export const isDurableWalterCommand = (command: WalterCommand) => durableCommandTypes.has(command.type);

export function persistentWalterSnapshot(snapshot: WalterSnapshot): WalterSnapshot {
  return {
    ...snapshot,
    audioLevel: 0,
    gaze: { x: 0, y: 0 },
    attention: { ...snapshot.attention, present: false, target: { x: 0, y: 0 }, confidence: 0 },
    input: { ...snapshot.input, level: 0 },
    output: { ...snapshot.output, level: 0, speaking: false },
    audio: { ...snapshot.audio, micLevel: 0, outputLevel: 0, listening: false },
    devices: { ...snapshot.devices, mic: "unknown", camera: "unknown", speaker: "unknown", brain: "unknown" },
    connection: { state: "offline", reconnects: 0, lastMessageAt: null },
  };
}
